
import roles from '../api/roles'

export const state = {
  roles: [],
  role_pagination_data: {},
  role: ''
}

export const getters = {
  roles: state => state.roles,
  role_pagination_data: state => state.role_pagination_data,
  role: state => state.role
}

export const mutations = {
  ADD_ROLE (state, data) {
    state.roles.push(data)
  },
  SET_ROLES (state, data) {
    state.roles = data
  },
  SET_ROLE_PAGINATION (state, data) {
    state.role_pagination_data = data
  },
  SHOW_ROLE (state, data) {
    state.role = data
  }
}

export const actions = {
  GET_ROLES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      roles.get({ page: data.page ? data.page : '', search: data.search ? data.search : '' }).then(response => {
        commit('SET_ROLES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_ROLE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_ROLE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      roles.create(data).then(response => {
        commit('ADD_ROLE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_ROLE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      roles.show(id).then(response => {
        commit('SHOW_ROLE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_ROLE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      roles.update(data, state.role.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_ROLE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      roles.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js